const Transaction = {
	Product: {value: '', auto: []},
	ItemId: {value: '', auto: []},
	Strength: {value: '', auto: []},
	DoseForm: {value: '', auto: []},
	ContainerSize: {value: '', auto: []},
	LotId: {value: '', auto: []},
	LotExp: {value: '', auto: []},
	Quantity: {value: '', auto: []}
};
const Manufacturer = {
	Name: {value: '', auto: []},
	Address: {value: '', auto: []},
	City: {value: '', auto: []},
	State: {value: '', auto: []},
	Zip: {value: '', auto: []},
	BulkLotId: {value: '', auto: []},
	Exp: {value: '', auto: []},
	ContainerSize: {value: '', auto: []},
	NDC: {value: '', auto: []},
	Invoice: {value: '', auto: []},
	TransactionDate: {value: '', auto: []}
};
const Distributor = {
	Invoice: {value: '', auto: []},
	TransactionDate: {value: '', auto: []},
	Name: {value: '', auto: []},
	Address: {value: '', auto: []},
	City: {value: '', auto: []},
	State: {value: '', auto: []},
	Zip: {value: '', auto: []}
};
const S3Object = {
    bucket: {value: '', auto: []},
    region: {value: '', auto: []},
    key: {value: '', auto: []}
};
export const Pedigree = {
	id: {value: '', auto: []},
	IssuedTo: {value: '', auto: []},
	ClientId: {value: '', auto: []},
	Invoice: {value: '', auto: []},
	TransactionDate: {value: '', auto: []},
	PurchaseDate: {value: '', auto: []},
	Published: {value: 'NEW', auto: []},
	PedType: {value: 'USER', auto: []},
	GroupID: {value: '', auto: []},
	ExpiresAt: {value: 0, auto: []},
	PDF: S3Object,
	Transaction: Transaction,
	Manufacturer: Manufacturer,
	Distributors: [Distributor]
};